import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { FeesSection, CorrespondentOnlySection, DynamicFee } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface OriginationFeesFormData {
  applicationFee: number;
  loanOriginationFee: number;
  discountPointFee: number;
  underwriterFee: number;
  processorFee: number;
  dynamicFees: DynamicFee[];
}

@Component({
  selector: 'origination-fees',
  templateUrl: './origination-fees.component.html',
  styleUrls: ['./origination-fees.component.scss'],
  standalone: false
})
export class OriginationFeesComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('originationFeesForm') originationFeesForm: NgForm;

  @Input() fees: FeesSection | undefined;
  @Input() correspondentOnly: CorrespondentOnlySection | undefined;

  formData: OriginationFeesFormData = {
    applicationFee: null,
    loanOriginationFee: null,
    discountPointFee: null,
    underwriterFee: null,
    processorFee: null,
    dynamicFees: []
  };

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fees'] || changes['correspondentOnly']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.originationFeesForm) {
      this.originationFeesForm.form.markAllAsTouched();
      return this.originationFeesForm.form.valid;
    }
    return true;
  }

  getFormData(): OriginationFeesFormData {
    return {
      ...this.formData,
      dynamicFees: [...this.formData.dynamicFees]
    };
  }

  addDynamicFee(): void {
    this.formData.dynamicFees.push({ uuid: crypto.randomUUID(), name: '', amount: null });
  }

  removeDynamicFee(index: number): void {
    this.formData.dynamicFees.splice(index, 1);
  }

  private populateFormFromApiData(): void {
    if (this.fees) {
      this.formData.applicationFee = this.fees.applicationFee || null;
      this.formData.loanOriginationFee = this.fees.loanOriginationFee || null;
      this.formData.discountPointFee = this.fees.discountPointFee ||  null;

      this.formData.underwriterFee = this.fees.underwriterFee || null;
      this.formData.processorFee = this.fees.processorFee || null;
      this.formData.dynamicFees = this.fees.dynamicOriginationFees?.map(fee => ({
        ...fee,
        uuid: fee.uuid || crypto.randomUUID()
      })) || [];
    }
  }
}
